import React, { FC, memo } from 'react';
import classes from './practiceCarousel.module.css';
import joy_boy from 'static/materials/joy_boy.png';

export const FourthView: FC = memo(() => {
  return (
    <>
      <div className={classes.blackBorder}>
        昇級テストに挑むまでの流れは
        <br />
        <span style={{ color: '#ff0000' }}>かんたん3ステップ</span>
      </div>
      <div className={classes.joyboyWrapper}>
        <img src={joy_boy} alt=""></img>
      </div>
    </>
  );
});
